"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _calendarwidget = _interopRequireDefault(require("../calendar-widget/calendarwidget"));

var _calendarbody = _interopRequireDefault(require("./calendarbody.proptypes"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CalenderBody = _styledComponents.default.div.withConfig({
  displayName: "calendarbody__CalenderBody",
  componentId: "sc-jk2x8b-0"
})(function (_ref) {
  var theme = _ref.theme;
  return "\n    background-color: ".concat(theme.colors.default, ";\n    border:  1px solid ").concat(theme.colors.greyLight, ";\n    padding: ").concat(theme.space.small, ";\n  ");
});

var AaCalendarBody = function AaCalendarBody(props) {
  var calendarModalConfig = props.calendarModalConfig,
      toReset = props.toReset,
      resetToPrefilledDates = props.resetToPrefilledDates,
      showCalendarModal = props.showCalendarModal,
      selectForDepart = props.selectForDepart,
      selectForReturn = props.selectForReturn,
      dateFormatData = props.dateFormatData,
      tempDepart = props.tempDepart,
      tempReturn = props.tempReturn,
      theme = props.theme,
      enableLFC = props.enableLFC,
      enableLFCV2 = props.enableLFCV2,
      environment = props.environment,
      lfcDepartEndpoint = props.lfcDepartEndpoint,
      lfcReturnEndpoint = props.lfcReturnEndpoint,
      lfcConfig = props.lfcConfig,
      isSnapCalendar = props.isSnapCalendar,
      isPartialHotelCalendar = props.isPartialHotelCalendar,
      flightDepart = props.flightDepart,
      flightReturn = props.flightReturn,
      minNights = props.minNights,
      currencyFormatData = props.currencyFormatData,
      prefillLfcOneWayPrice = props.prefillLfcOneWayPrice,
      prefillLfcReturnPrice = props.prefillLfcReturnPrice,
      snapLfcPrices = props.snapLfcPrices,
      customDateLabels = props.customDateLabels,
      isOnlyApplyForHotel = props.isOnlyApplyForHotel,
      enableAvailableDateCalendarFlag = props.enableAvailableDateCalendarFlag,
      setIsFareLoadedV2 = props.setIsFareLoadedV2,
      domain = props.domain;
  return /*#__PURE__*/_react.default.createElement(CalenderBody, {
    id: isPartialHotelCalendar && 'partialHotelCalendarBody' || 'calenderbody'
  }, /*#__PURE__*/_react.default.createElement(_calendarwidget.default, {
    controls: _objectSpread(_objectSpread({}, calendarModalConfig.controls), {}, {
      resetData: toReset,
      resetToPrefilledDates: resetToPrefilledDates,
      selectForDepart: showCalendarModal && selectForDepart,
      selectForReturn: selectForReturn
    }),
    dataFormatDate: dateFormatData,
    dataFormatCurrency: currencyFormatData,
    dates: {
      departDate: tempDepart,
      returnDate: tempReturn
    },
    lfcConfig: lfcConfig,
    enableLFC: enableLFC,
    enableLFCV2: enableLFCV2,
    isSnapCalendar: isSnapCalendar,
    isPartialHotelCalendar: isPartialHotelCalendar,
    flightDepart: flightDepart,
    flightReturn: flightReturn,
    minNights: minNights,
    environment: environment,
    lfcDepartEndpoint: lfcDepartEndpoint,
    lfcReturnEndpoint: lfcReturnEndpoint,
    theme: theme,
    prefillLfcOneWayPrice: prefillLfcOneWayPrice,
    prefillLfcReturnPrice: prefillLfcReturnPrice,
    snapLfcPrices: snapLfcPrices,
    customDateLabels: customDateLabels,
    isOnlyApplyForHotel: isOnlyApplyForHotel,
    enableAvailableDateCalendarFlag: enableAvailableDateCalendarFlag,
    setIsFareLoadedV2: setIsFareLoadedV2,
    domain: domain
  }));
};

AaCalendarBody.propTypes = _calendarbody.default.PropTypes;
var _default = AaCalendarBody;
exports.default = _default;